/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_License_PlateInputs */

const en_case_field_license_plate = /** @type {(inputs: Case_Field_License_PlateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License plate`)
};

const pt_br2_case_field_license_plate = /** @type {(inputs: Case_Field_License_PlateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placa`)
};

/**
* | output |
* | --- |
* | "License plate" |
*
* @param {Case_Field_License_PlateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_license_plate = /** @type {((inputs?: Case_Field_License_PlateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_License_PlateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_license_plate(inputs)
	return pt_br2_case_field_license_plate(inputs)
});